export default "__VITE_ASSET__4fee0d23__"